import styled from 'styled-components';

const ButtonStyled = styled.button`
  background-color: ${({ theme }) => theme.colors.primary};
  border: none;
  color: ${({ theme }) => theme.colors.bg.primary};
  font: ${({ theme }) =>
    `${theme.font.size.xSmallCalc} ${theme.font.family.bold}`};
  height: 4.5vh;
  max-height: 50px;
  max-width: 300px;
  min-height: 40px;
  min-width: 155px;
  padding: 7px 10px;
  text-transform: uppercase;
  width: ${({ width }) => width || '60vw'};

  &:hover {
    filter: brightness(0.85);
  }
`;

export default ButtonStyled;
